import React from 'react';
import { useTranslation } from 'react-i18next';
import SelectFilter, { OPTION_ALL } from './SelectFilter';
import { CODE_95_POINTS_PROGRESSION, NO_CYCLE_CYCLE_REQUIRED } from '../../../utils/code95';
import { Column, FilterFnOption } from '@tanstack/react-table';
import { Code95DataEntry } from '../EmployeeList/Code95/Code95Overview';

const PLUS_35 = '35+';

type Props = {
	column: Column<Code95DataEntry, unknown>;
};

function Code95Filter({ column }: Props) {
	const { t } = useTranslation();

	const filterValue = column.getFilterValue();
	const setFilter = (filter: string) => column.setFilterValue(filter);

	const options = [
		{ value: OPTION_ALL, key: OPTION_ALL, name: t('table.all') },
		{
			value: NO_CYCLE_CYCLE_REQUIRED,
			key: NO_CYCLE_CYCLE_REQUIRED,
			name: t('dashboard.no_current_cycle'),
		},
		// remove the last element from the points progression, since a custom value is required
		...CODE_95_POINTS_PROGRESSION.slice(0, 5).map((amount) => ({
			value: amount,
			key: amount,
			name: amount,
		})),
		{ value: PLUS_35, key: PLUS_35, name: PLUS_35 },
	];

	return (
		<SelectFilter
			id={column.id}
			filterValue={filterValue}
			setFilter={setFilter}
			options={options}
		/>
	);
}

export const code95Filter: FilterFnOption<Code95DataEntry> = (
	row,
	columnId,
	filterValue,
): boolean => {
	if (filterValue === OPTION_ALL) {
		return true;
	}

	if (Number(filterValue) === NO_CYCLE_CYCLE_REQUIRED) {
		return row.original.currentCycle === null;
	}

	const code95Hours =
		parseInt(row.original.currentCycle?.practiceHours || '0', 10) +
		parseInt(row.original.currentCycle?.theoryHours || '0', 10);
	if (filterValue === PLUS_35) {
		return code95Hours >= 35;
	}

	return code95Hours === parseInt(filterValue, 10);
};

export default Code95Filter;
